module.exports = __webpack_public_path__ + "img/Recurso 7.9c028e8e.png";